export default __webpack_public_path__ + "static/media/BST_S.730cbd77.png";